export const ProviderConsoleModuleRegistry = [
    { id: 1, key: 'provider.orders', label: 'Orders', scope: 'provider' },
    { id: 2, key: 'provider.sales', label: 'Sales', scope: 'provider' },
    { id: 3, key: 'provider.products', label: 'Products', scope: 'provider' },
    { id: 4, key: 'provider.notifications', label: 'Notifications', scope: 'provider' },
    { id: 5, key: 'provider.scheduling', label: 'Scheduling', scope: 'provider' },
    { id: 6, key: 'provider.order_tests', label: 'Order Tests', scope: 'provider' },
];
export const ProviderConsoleModules = {
    orders: ProviderConsoleModuleRegistry[0].key,
    sales: ProviderConsoleModuleRegistry[1].key,
    products: ProviderConsoleModuleRegistry[2].key,
    notifications: ProviderConsoleModuleRegistry[3].key,
    scheduling: ProviderConsoleModuleRegistry[4].key,
    orderTests: ProviderConsoleModuleRegistry[5].key,
};
export const ProviderConsoleModuleIds = {
    [ProviderConsoleModules.orders]: 1,
    [ProviderConsoleModules.sales]: 2,
    [ProviderConsoleModules.products]: 3,
    [ProviderConsoleModules.notifications]: 4,
    [ProviderConsoleModules.scheduling]: 5,
    [ProviderConsoleModules.orderTests]: 6,
};
export const ProviderConsoleModuleLabels = {
    [ProviderConsoleModules.orders]: 'Orders',
    [ProviderConsoleModules.sales]: 'Sales',
    [ProviderConsoleModules.products]: 'Products',
    [ProviderConsoleModules.notifications]: 'Notifications',
    [ProviderConsoleModules.scheduling]: 'Scheduling',
    [ProviderConsoleModules.orderTests]: 'Order Tests',
};
export const ProviderConsoleModuleKeyById = {
    1: ProviderConsoleModules.orders,
    2: ProviderConsoleModules.sales,
    3: ProviderConsoleModules.products,
    4: ProviderConsoleModules.notifications,
    5: ProviderConsoleModules.scheduling,
    6: ProviderConsoleModules.orderTests,
};
export const ProviderConsolePermissions = {
    ordersView: 'provider.orders.view',
    ordersViewPii: 'provider.orders.view_pii',
    ordersSearch: 'provider.orders.search',
    salesView: 'provider.sales.view',
    productsView: 'provider.products.view',
    notificationsView: 'provider.notifications.view',
    schedulingView: 'provider.scheduling.view',
    orderTestsView: 'provider.order_tests.view',
    orderTestsCreate: 'provider.order_tests.create',
};
export const PROVIDER_CONSOLE_MODULE_KEYS = ProviderConsoleModuleRegistry.map((module) => module.key);
export const PROVIDER_CONSOLE_MODULE_IDS = ProviderConsoleModuleRegistry.map((module) => module.id);
export const PROVIDER_CONSOLE_PERMISSION_KEYS = [
    ProviderConsolePermissions.ordersView,
    ProviderConsolePermissions.ordersViewPii,
    ProviderConsolePermissions.ordersSearch,
    ProviderConsolePermissions.salesView,
    ProviderConsolePermissions.productsView,
    ProviderConsolePermissions.notificationsView,
    ProviderConsolePermissions.schedulingView,
    ProviderConsolePermissions.orderTestsView,
    ProviderConsolePermissions.orderTestsCreate,
];
export const PROVIDER_CONSOLE_MODULE_REQUIRED_PERMISSIONS = {
    [ProviderConsoleModules.orders]: ProviderConsolePermissions.ordersView,
    [ProviderConsoleModules.sales]: ProviderConsolePermissions.salesView,
    [ProviderConsoleModules.products]: ProviderConsolePermissions.productsView,
    [ProviderConsoleModules.notifications]: ProviderConsolePermissions.notificationsView,
    [ProviderConsoleModules.scheduling]: ProviderConsolePermissions.schedulingView,
    [ProviderConsoleModules.orderTests]: ProviderConsolePermissions.orderTestsView,
};
